<template>
    <div>
        <b-row>
            <b-col md=12 v-if="cropperiod_data">
                <!-- 封面區域 -->
                <div class="cover-bg" :style="$tools.style.imgCover($config.checkURL('pic',cropperiod_data.project_pic))">
                    <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                        <b-col md="5" class="text-center">
                            <div class="proj-logo-area">
                                <!-- <h4>{{ cropperiod_data.project_name }} {{ cropperiod_data.name }}</h4> -->

                                <h2 class="text-center">
                                    {{ $t('menu.crop_records') }}
                                </h2>

                                <!-- <h5 class="text-center">{{ getDateRange }}</h5> -->
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    props: {
        cropperiod_data: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>

.proj-cover
{
    height: 150px;
}

</style>